import 'promise-polyfill/src/polyfill'

import './element/matches'
import './element/closest'

import './array/forEach'
import './array/from'

import './object/forEach'
import './object/assign'


// WEBPACK FOOTER //
// ./src/js/polyfills/index.js